export const QUERY_KEYS = {
  CAMPAIGN_DETAILS: 'campaignDetails',
  CAMPAIGN_PERFORMANCE: 'campaignPerformance',
  CAMPAIGNS_LIST: 'campaignsList',
  ADVERTISERS_FILTER: 'advertisersFilter',
  CREATABLE_MEDIA_TYPES: 'creatableMediaTypes',
  THEMATIC_PACKAGES: 'thematicPackages',
} as const;
